import { isFieldReadonlyEntity } from '@/modules/erp-campos/erp-campos-utils';

export default {
  inserted(el, binding) {
    const { field, bloqueios, isEdicao } = binding.value;
    const isBlocked = isEdicao && isFieldReadonlyEntity(field, bloqueios);

    if (isBlocked) {
      setTimeout(() => {
        el.setAttribute('disabled', true);
        el.classList.add('v-input--is-disabled');
      });
    }
  },
  update(el, binding) {
    const { field, bloqueios, isEdicao } = binding.value;
    const isBlocked = isEdicao && isFieldReadonlyEntity(field, bloqueios);

    if (isBlocked) {
      el.setAttribute('disabled', true);
      el.classList.add('v-input--is-disabled');
    } else {
      el.removeAttribute('disabled');
      el.classList.remove('v-input--is-disabled');
    }
  },
};
